import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

// Lazy load components
const Home = lazy(() => import("../pages/Home/Home"));
const Projects = lazy(() => import("../pages/Projects/Projects"));
const About = lazy(() => import("../pages/About/About"));
const Resume = lazy(() => import("../pages/Resume/ResumeNew"));

// Define route configurations
const routes = [
  { path: "/", element: <Home /> },
  { path: "/project", element: <Projects /> },
  { path: "/about", element: <About /> },
  { path: "/resume", element: <Resume /> },
  { path: "*", element: <Navigate to="/" /> },
];

export default routes;
